class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

document.addEventListener('DOMContentLoaded', function() {
  const desktopInput = document.querySelector('.desktop-search-input');
  const suggestionsBox = document.querySelector('.desktop-search-suggestions');
  let debounceTimeout;

  if (desktopInput && suggestionsBox) {
    function getProductImage(product) {
      if (product.featured_image) {
        if (typeof product.featured_image === 'string') return product.featured_image;
        if (typeof product.featured_image === 'object' && product.featured_image.url) return product.featured_image.url;
      }
      return '/assets/placeholder.png';
    }
    desktopInput.addEventListener('input', function(e) {
      const query = this.value.trim();
      clearTimeout(debounceTimeout);
      if (query.length < 2) {
        suggestionsBox.style.display = 'none';
        suggestionsBox.innerHTML = '';
        return;
      }
      debounceTimeout = setTimeout(() => {
        fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`)
          .then(res => res.json())
          .then(data => {
            const products = data.resources?.results?.products || [];
            if (products.length === 0) {
              suggestionsBox.innerHTML = '<div class="desktop-search-suggestion-item" tabindex="-1">No products found</div>';
              suggestionsBox.style.display = 'block';
              return;
            }
            suggestionsBox.innerHTML = products.map(product => `
              <a href="${product.url}" class="desktop-search-suggestion-item" tabindex="0">
                <img src="${getProductImage(product)}" class="desktop-search-suggestion-image" alt="${product.title}">
                <span class="desktop-search-suggestion-title">${product.title}</span>
<span class="desktop-search-suggestion-price">${parseFloat(product.price).toLocaleString('en-IN', {style:'currency',currency:'INR'})}</span>              </a>
            `).join('');
            suggestionsBox.style.display = 'block';
          });
      }, 200);
    });
    desktopInput.addEventListener('focus', function() {
      if (suggestionsBox.innerHTML.trim() !== '') {
        suggestionsBox.style.display = 'block';
      }
    });
    desktopInput.addEventListener('blur', function() {
      setTimeout(() => { suggestionsBox.style.display = 'none'; }, 150);
    });
    suggestionsBox.addEventListener('mousedown', function(e) {
      const link = e.target.closest('.desktop-search-suggestion-item[href]');
      if (link) {
        window.location.href = link.getAttribute('href');
      }
    });
  }
});
